import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { ApolloProvider } from "@apollo/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import client from "services/api/apolloClient";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import "./index.scss";
import { ModalProvider } from "./context/ModalContext";
import ModalWrapper from "./components/Modal/ModalWrapper";
import { SentryProvider } from "./sentry/SentryProvider";
import ErrorReportListener from "./sentry/ErrorReportListener";
import { Capacitor } from "@capacitor/core";

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker
//       .register("/firebase-messaging-sw.js")
//       // eslint-disable-next-line no-unused-vars
//       .then((registration) => {
//         // eslint-disable-next-line no-console
//         console.log("Service Worker registered successfully: ", registration.scope);
//       })
//       // eslint-disable-next-line no-unused-vars
//       .catch((error) => {
//         // eslint-disable-next-line no-console
//         console.error("Service Worker registration failed: ", error);
//       });
//   });
// }

if (Capacitor.isNativePlatform()) {
  // add capacitor-fixes.css to head only for mobile app
  const head = document.getElementsByTagName("head")[0];
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = "/styles/capacitor-fixes.css";
  head.appendChild(link);
}

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <SentryProvider>
        <PersistGate loading={null} persistor={persistor}>
          <ApolloProvider client={client}>
            <QueryClientProvider client={queryClient}>
              <ModalProvider>
                <App />
                <ModalWrapper />
                <ErrorReportListener />
              </ModalProvider>
            </QueryClientProvider>
          </ApolloProvider>
        </PersistGate>
      </SentryProvider>
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
